import {
  
  FormDateRangePicker,
  FormSelect,
  Loader,
} from "@/components";
import useFilter from "./useFilter";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { X } from "lucide-react";
import { FC } from "react";
import { FilterProps } from "./types";
import {
  CREATED_BY,
  DATE_RANGE,
  INVOICE_STATUS,
  invoiceStatusOptions,
  PAYMENT_STATUS,
  paymentStatusOptions,
  VENDOR_ID,
} from "../consts";

const Filter: FC<FilterProps> = ({ onCancel, filterData, setFilterData }) => {
  const {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
    isVendorLoading,
    vendorList,
  } = useFilter({
    filterData,
    setFilterData,
    onCancel,
  });
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">Filter</DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        {isVendorLoading ? (
          <Loader />
        ) : (
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
              <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[130px] px-1">
                <div className="grid grid-cols-1 gap-[25px]">
                  <FormDateRangePicker
                    name={DATE_RANGE}
                    control={form.control}
                    label="Posted Date Range"
                    placeholder="Please enter"
                    error={errors[DATE_RANGE]?.message}
                    isRequired={requiredFields.includes(DATE_RANGE)}
                    onClear={() => {
                      form.setValue(DATE_RANGE, "");
                    }}
                  />
                  <FormSelect
                    multiSelect
                    name={VENDOR_ID}
                    control={form.control}
                    label="Vendor Name"
                    placeholder="Please enter"
                    error={errors[VENDOR_ID]?.message}
                    isRequired={requiredFields.includes(VENDOR_ID)}
                    options={vendorList?.map((data: any) => {
                      return {
                        label: data?.vendorName?.toString(),
                        value: data?.vendorId?.toString(),
                      };
                    })}
                  />
                  <FormSelect
                    name={INVOICE_STATUS}
                    control={form.control}
                    label="Invoice Status"
                    placeholder="Please enter"
                    error={errors[INVOICE_STATUS]?.message}
                    isRequired={requiredFields.includes(INVOICE_STATUS)}
                    options={invoiceStatusOptions}
                  />
                  <FormSelect
                    name={CREATED_BY}
                    control={form.control}
                    label="Created By"
                    placeholder="Please enter"
                    error={errors[CREATED_BY]?.message}
                    isRequired={requiredFields.includes(CREATED_BY)}
                  />
                  <FormSelect
                    name={PAYMENT_STATUS}
                    control={form.control}
                    label="Payment Status"
                    placeholder="Please enter"
                    error={errors[PAYMENT_STATUS]?.message}
                    isRequired={requiredFields.includes(PAYMENT_STATUS)}
                    options={paymentStatusOptions}
                  />
                </div>
              </div>
              <div className="flex flex-row gap-3 absolute bottom-3 w-full bg-white pb-[25px] z-[3] justify-end">
                <Button variant="secondary" type="button" onClick={onClear}>
                  Clear All
                </Button>
                <Button type="submit">Apply Filter</Button>
              </div>
            </form>
          </FormProvider>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default Filter;
